export const hasError = (p) => p.src && p.error && !p.isLoading;

export const noImg = (p) => !p.src || p.error || p.isLoading;

export const noSrc = (p) => !p.src && !p.isLoading;
